import { ReactNode, forwardRef } from "react";
import Carousel, { OverflowCarousel } from "@ingka/carousel";

import "@ingka/svg-icon/dist/style.css";
import "@ingka/button/dist/style.css";
import "@ingka/carousel/dist/style.css";
import "@ingka/focus/dist/style.css";

type FixaOverflowCarouselProps = {
  children?: ReactNode;
  id?: string;
  controlBtnType?:
    | "primary"
    | "emphasised"
    | "secondary"
    | "tertiary"
    | "danger"
    | "plain"
    | "image-overlay";
  "data-testid"?: string;
  slideIndex?: number;
};

export function FixaOverflowCarousel(props: FixaOverflowCarouselProps) {
  return <OverflowCarousel {...props} />;
}

/** Minimal surface of the @ingka/carousel Carousel class instance we need. */
export interface FixaCarouselHandle {
  goToIndex: (index: number) => void;
}

type FixaCarouselProps = {
  children?: React.ReactElement[];
  hasNoControls?: boolean;
  id: string;
  isSlideShow?: boolean;
  onVisibleSlideChange?: (visibleIndices: number[]) => void;
  ariaLabelLeftBtn?: string;
  ariaLabelRightBtn?: string;
  "data-testid"?: string;
  slideIndex?: number;
  className?: string;
  hasSlideCounter?: boolean;
};

const FixaCarousel = forwardRef<FixaCarouselHandle, FixaCarouselProps>(
  (props, ref) => {
    return (
      <Carousel
        ref={ref as unknown as React.Ref<any>}
        {...props}
        hasSlideCounter={props.hasSlideCounter ?? false}
      />
    );
  }
);
FixaCarousel.displayName = "FixaCarousel";

export default FixaCarousel;
